import { render, staticRenderFns } from "./LinkQR034.vue?vue&type=template&id=dd4a4818&scoped=true&"
import script from "./LinkQR034.vue?vue&type=script&lang=js&"
export * from "./LinkQR034.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR034.vue?vue&type=style&index=0&id=dd4a4818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4a4818",
  null
  
)

export default component.exports